import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import CompaniesService from '../../../../services/companies/companies.service'
import UsersService from '../../../../services/users/users.service'
import { ACTIVITY_TYPES } from '../../../../utils/constants/activityTypes'
import { ZONES } from '../../../../utils/constants/zones'
import LabeledDropdown from '../../../../components/common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledCheckbox from '../../../../components/common/form-components/labeled-checkbox/LabeledCheckbox'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService from '../../../../services/centers/center.service'
import CenterSettingsService from '../../../../services/settings/centers/centerSettings.service'

import './centerForm.scss'
import DeleteButton from '../../../../components/common/buttons/DeleteButton'
import SaveButton from '../../../../components/common/buttons/SaveButton'
import swalAlert from '../../../../utils/helpers/swalAlert'
import { AppModalContent } from '../../../../component/layout/AppModal'
import { Group, Stack } from '@mantine/core'
import EntityDropdown from '../../../../component/form/EntityDropdown'
import AppCheckbox from '../../../../component/form/AppCheckbox'
import AppButton from '../../../../component/common/AppButton'

const CenterTechnicsTrackForm = ({
  centerId,
  selectedItem,
  close,
  updateInputs: updateTechnicsInputs,
}) => {
  const { formatMessage: msg } = useIntl()

  const [trackTypes, setTrackTypes] = useState()
  const [plattenTypes, setPlattenTypes] = useState()

  const { inputs, onChangeInputs, updateInputs } = useInputs()

  useEffect(() => {
    getTrackTypes()
    getPlattenTypes()
  }, [])

  useEffect(() => {
    updateInputs(selectedItem)
    // if(selectedItem)
  }, [selectedItem])

  const getTrackTypes = async () => {
    const response = await CenterSettingsService.trackTypes.getAll({})
    if (response) {
      setTrackTypes(response.resp)
    }
  }

  const getPlattenTypes = async () => {
    const response = await CenterSettingsService.plattenTypes.getAll({})
    if (response) {
      setPlattenTypes(response.resp)
    }
  }

  const handleSave = async () => {
    // console.log('handleSave')
    if (centerId && centerId !== 'undefined' && !selectedItem) {
      const data = {
        ...inputs,
      }
      const response = await CenterService?.technics?.tracks?.create({
        id: centerId,
        body: data,
      })
      // console.log('response', response)
      if (response) {
        updateTechnicsInputs(response?.resp)
        close()
      }
    }
  }

  const handleRemove = async () => {
    if (selectedItem?._id) {
      const response = await CenterService?.technics?.tracks?.remove({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response) {
        updateTechnicsInputs(response?.resp)
        close()
        swalAlert('success', msg({ id: 'center.technics.track.removed' }))
      } else {
        swalAlert('error', msg({ id: 'center.technics.track.error' }))
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        selectedItem && <AppButton preset="remove" onClick={handleRemove} />,
        <AppButton preset="save" onClick={handleSave} />,
      ]}
      content={
        <Stack w="100%">
          <Group>
            <EntityDropdown
              icon="technics"
              label="trackType"
              withAsterisk
              name="trackTypesId"
              value={inputs?.trackTypesId}
              onChange={onChangeInputs}
              options={trackTypes}
            />
            <EntityDropdown
              icon="technics"
              label="plattenType"
              withAsterisk
              name="plattenTypesId"
              value={inputs?.plattenTypesId}
              onChange={onChangeInputs}
              options={plattenTypes}
            />
          </Group>
          <Group>
            <AppCheckbox
              size="lg"
              label="hyprocash"
              name="hyprocash"
              checked={inputs?.hyprocash}
              onChange={onChangeInputs}
            />
            <AppCheckbox
              size="lg"
              label="stopAndGo"
              name="stopAndGo"
              checked={inputs?.stopAndGo}
              onChange={onChangeInputs}
            />
          </Group>
        </Stack>
      }
    />
  )
}

export default CenterTechnicsTrackForm
